<script setup>
  import { useI18n } from 'vue-i18n';
  import RadioControl from '@/components/RadioControl.vue';

  const { t } = useI18n();

  const model = defineModel();

  // Values are i18n keys; translated at the render site.
  const options = {
    short: 'windAlerts.shortRange',
    long: 'windAlerts.longRange'
  };
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'model-range-' + value" class="jwx-table-view__row-label">{{ t(label) }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="model"
                name="model-range"
                :id="'model-range-' + value"
                :value="value"
                :srLabel="t('windAlerts.srSelect', { label: t(label) })"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
